import { service } from '@ember/service';
import ApplicationAdapter from 'lumen/adapters/application';
import type { HotelAndMarketServiceWithHotel } from 'lumen/services/hotel-and-market';

export default class OverrideAdapter extends ApplicationAdapter {
  @service('hotel-and-market')
  declare hotelAndMarketService: HotelAndMarketServiceWithHotel;
  baseUrl = `${this.host}/apigateway/v1/app/pricing-assistant/recommendations/overrides/`;

  // @ts-expect-error: Property 'buildURL' in type 'OverrideAdapter' is not assignable to the same property in base type 'ApplicationAdapter'.
  buildURL(
    modelName: string,
    id: string,
    snapshot: unknown,
    requestType: string,
  ): string {
    if (requestType === 'deleteRecord') {
      return this.urlForDeleteRecord(id);
    }

    return this.baseUrl;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  urlForDeleteRecord(id: string) {
    const subscriptionId = this.hotelAndMarketService.hotel.id;
    return `${this.baseUrl}?subscription_id=${subscriptionId}&overrides=${id}`;
  }
}
